module.exports = __webpack_public_path__ + "static/map_sp-4a3481d05af7a09d44008eceb0741b08.jpg";